export default "__VITE_ASSET__ed3720d3__"